import { useEffect, useState } from 'react';

type DelayedSkeletonProps = {
  delay?: number;
  children: React.ReactNode;
};

export function DelayedSkeleton({
  delay = 250,
  children,
}: DelayedSkeletonProps): React.ReactElement | null {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setVisible(true), delay);
    return () => clearTimeout(timeout);
  }, [delay]);

  if (!visible) return null;
  return <>{children}</>;
}
